import { defineMessages } from "react-intl";

const scope = "supportui.containers.ExportToExcel";

export default defineMessages({
  exportButtonText: {
    id: `${scope}.exportButtonText`,
    defaultMessage: "Export",
  },
});
